var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.097 5.034a7 7 0 0 1 12.32 4.55v1.25a1.583 1.583 0 0 1-3.167 0v-1.25a3.833 3.833 0 1 0-.774 2.309 2.584 2.584 0 0 0 4.94-1.06v-1.25a8 8 0 1 0-8 8 .5.5 0 0 0 0-1 7 7 0 0 1-5.32-11.55Zm3.166 2.708a2.833 2.833 0 1 1 4.307 3.683 2.833 2.833 0 0 1-4.307-3.683Z",
    fill: "#818C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.097 5.034a7 7 0 0 1 12.32 4.55v1.25a1.583 1.583 0 0 1-3.167 0v-1.25a3.833 3.833 0 1 0-.774 2.309 2.584 2.584 0 0 0 4.94-1.06v-1.25a8 8 0 1 0-8 8 .5.5 0 0 0 0-1 7 7 0 0 1-5.32-11.55Zm3.166 2.708a2.833 2.833 0 1 1 4.307 3.683 2.833 2.833 0 0 1-4.307-3.683Z",
    fill: "#747F88"
  })));
};

export default SvgMail;